import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useMiddlewareChangelogQuery } from '@entities/changelog'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const disciplineId = to.params.id

  if (typeof disciplineId !== 'string' || !disciplineId) return

  useMiddlewareChangelogQuery(to, {
    route: 'admin.disciplines.api.changelog',
    params: { discipline_id: disciplineId },
  })
})
